import React from 'react';

const TasksIcon = ({ color = '#757575', width = 20, height = 20, ...rest }, ref) => {
  return (
    <svg
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}>
      <path
        d="M13.3333 3.33594C15.1459 3.34603 16.1274 3.4264 16.7678 4.06672C17.5 4.79896 17.5 5.97747 17.5 8.33449V13.3345C17.5 15.6915 17.5 16.87 16.7678 17.6023C16.0355 18.3345 14.857 18.3345 12.5 18.3345H7.5C5.14298 18.3345 3.96447 18.3345 3.23223 17.6023C2.5 16.87 2.5 15.6915 2.5 13.3345V8.33449C2.5 5.97747 2.5 4.79896 3.23223 4.06672C3.87255 3.4264 4.85414 3.34603 6.66667 3.33594"
        stroke={color}
        strokeWidth="1.25"
      />
      <path d="M8.75 11.6641L14.1667 11.6641" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <path d="M5.8335 11.6641H6.25016" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <path d="M5.8335 8.75H6.25016" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <path d="M5.8335 14.5859H6.25016" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <path d="M8.75 8.75H14.1667" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <path d="M8.75 14.5859H14.1667" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <path
        d="M6.6665 2.91406C6.6665 2.22371 7.22615 1.66406 7.9165 1.66406H12.0832C12.7735 1.66406 13.3332 2.22371 13.3332 2.91406V3.7474C13.3332 4.43775 12.7735 4.9974 12.0832 4.9974H7.9165C7.22615 4.9974 6.6665 4.43775 6.6665 3.7474V2.91406Z"
        stroke={color}
        strokeWidth="1.25"
      />
    </svg>
  );
};

export default React.forwardRef(TasksIcon);
